// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-overlay {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: rgba(0, 0, 0, 0.6);
    color: white;
    padding: 20px;
    width: 30%; 
    min-width: 375px;
    text-align: center; 
    border-radius: 10px; 
}

.about-heading {
    font-size: 4rem;
    color: rgba(232, 77, 25, 0.86);
    margin: 0 0 20px;
    font-weight: bold;
}

.about-text p {
    font-size: 1.5rem;
    margin-top: 20px;
    margin-bottom: 20px;
    color: #f5f5f5;
    font-weight: normal;
}

.about-superscript {
    font-size: 0.8rem;
}

.about-heading, .about-text {
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5); 
}
`, "",{"version":3,"sources":["webpack://./src/About.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,oCAAoC;IACpC,YAAY;IACZ,aAAa;IACb,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,8BAA8B;IAC9B,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,2CAA2C;AAC/C","sourcesContent":[".text-overlay {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background-color: rgba(0, 0, 0, 0.6);\n    color: white;\n    padding: 20px;\n    width: 30%; \n    min-width: 375px;\n    text-align: center; \n    border-radius: 10px; \n}\n\n.about-heading {\n    font-size: 4rem;\n    color: rgba(232, 77, 25, 0.86);\n    margin: 0 0 20px;\n    font-weight: bold;\n}\n\n.about-text p {\n    font-size: 1.5rem;\n    margin-top: 20px;\n    margin-bottom: 20px;\n    color: #f5f5f5;\n    font-weight: normal;\n}\n\n.about-superscript {\n    font-size: 0.8rem;\n}\n\n.about-heading, .about-text {\n    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5); \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
